import { render, staticRenderFns } from "./CCard.vue?vue&type=template&id=5aa19e06&scoped=true&"
import script from "./CCard.vue?vue&type=script&lang=js&"
export * from "./CCard.vue?vue&type=script&lang=js&"
import style0 from "./CCard.vue?vue&type=style&index=0&id=5aa19e06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa19e06",
  null
  
)

export default component.exports